var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.592529,
    width: 18.7963,
    height: 18.7963,
    rx: 4,
    fill: "#00B103",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57015 6.25495L8.36887 5.80207C8.23726 5.50596 8.17146 5.35789 8.07305 5.24459C7.94971 5.10259 7.78895 4.99812 7.6091 4.94308C7.46559 4.89917 7.30357 4.89917 6.97952 4.89917C6.50549 4.89917 6.26847 4.89917 6.06951 4.99029C5.83514 5.09763 5.62348 5.3307 5.53914 5.5743C5.46755 5.78109 5.48806 5.99361 5.52907 6.41864C5.96563 10.9428 8.44596 13.4231 12.97 13.8596C13.3951 13.9007 13.6076 13.9212 13.8144 13.8496C14.058 13.7652 14.2911 13.5535 14.3984 13.3192C14.4895 13.1202 14.4895 12.8832 14.4895 12.4092C14.4895 12.0851 14.4895 11.9231 14.4456 11.7796C14.3906 11.5997 14.2861 11.439 14.1441 11.3157C14.0308 11.2172 13.8828 11.1515 13.5866 11.0198L13.1338 10.8185C12.8131 10.676 12.6527 10.6048 12.4898 10.5893C12.3339 10.5744 12.1766 10.5963 12.0307 10.6532C11.8782 10.7126 11.7434 10.8249 11.4738 11.0495C11.2054 11.2732 11.0713 11.385 10.9073 11.4449C10.7619 11.498 10.5698 11.5177 10.4167 11.4951C10.244 11.4696 10.1118 11.399 9.84733 11.2576C9.02453 10.8179 8.57078 10.3642 8.13106 9.54136C7.98973 9.27692 7.91907 9.14466 7.89362 8.972C7.87106 8.81889 7.89073 8.62674 7.94382 8.48142C8.00372 8.31745 8.11554 8.18328 8.33917 7.91491C8.56383 7.64532 8.67616 7.51053 8.73555 7.35801C8.79239 7.21206 8.81427 7.05483 8.79944 6.89891C8.78393 6.73597 8.71267 6.57563 8.57015 6.25495Z",
    stroke: "#006838",
    strokeWidth: 0.749812,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.25493de42acc5e8487a454e7a459e7e3.svg";
export { ForwardRef as ReactComponent };